module.exports = __webpack_public_path__ + "static/media/codeGuard.8619fe97.svg";